
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import ProspectModel from '@/models/ProspectModel'
import convertDateDirective from '@/directives/convertDateDirective'
import {isCoprolibDate} from '@/helpers/validators'

@Component({
  components: {
    BaseFormContainer
  },
  directives: {
    convertDateDirective
  },
  validations: {
    form: {
      DATE_CLOTURE: {
        isCoprolibDate
      }
    }
  }
})
export default class ProspectClotureForm extends BaseForm {
  model = ProspectModel
}
